export const LOAD_ENV_SUCCESS = 'LOAD_ENV_SUCCESS';
export const ENV_ERROR = 'ENV_ERROR';
